import { render } from "./SubManage.vue?vue&type=template&id=2221e6a0&scoped=true"
import script from "./SubManage.vue?vue&type=script&lang=js"
export * from "./SubManage.vue?vue&type=script&lang=js"

import "./SubManage.vue?vue&type=style&index=0&id=2221e6a0&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2221e6a0"]])

export default __exports__